<svg
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 487 846"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
>
  <defs>
    <linearGradient x1="50%" y1="-0.866876509%" x2="50%" y2="97.368376%" id="linearGradient-1">
      <stop stop-color="#FFFFFF" offset="0%"></stop>
      <stop stop-color="#FFFFFF" offset="100%"></stop>
    </linearGradient>
    <path
      d="M51.277704,-2.07168062e-15 L330.722296,2.07168062e-15 C348.552671,-1.2037061e-15 355.018396,1.85651222 361.536914,5.34265408 C368.055433,8.82879593 373.171204,13.9445674 376.657346,20.4630859 C380.143488,26.9816044 382,33.4473292 382,51.277704 L382,689.722296 C382,707.552671 380.143488,714.018396 376.657346,720.536914 C373.171204,727.055433 368.055433,732.171204 361.536914,735.657346 C355.018396,739.143488 348.552671,741 330.722296,741 L51.277704,741 C33.4473292,741 26.9816044,739.143488 20.4630859,735.657346 C13.9445674,732.171204 8.82879593,727.055433 5.34265408,720.536914 C1.85651222,714.018396 8.02470732e-16,707.552671 -1.38112041e-15,689.722296 L1.38112041e-15,51.277704 C-8.02470732e-16,33.4473292 1.85651222,26.9816044 5.34265408,20.4630859 C8.82879593,13.9445674 13.9445674,8.82879593 20.4630859,5.34265408 C26.9816044,1.85651222 33.4473292,1.2037061e-15 51.277704,-2.07168062e-15 Z"
      id="path-2"
    ></path>
    <filter
      x="-24.2%"
      y="-9.0%"
      width="148.4%"
      height="125.0%"
      filterUnits="objectBoundingBox"
      id="filter-3"
    >
      <feOffset dx="0" dy="26" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
      <feGaussianBlur
        stdDeviation="26.5"
        in="shadowOffsetOuter1"
        result="shadowBlurOuter1"
      ></feGaussianBlur>
      <feComposite
        in="shadowBlurOuter1"
        in2="SourceAlpha"
        operator="out"
        result="shadowBlurOuter1"
      ></feComposite>
      <feColorMatrix
        values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.132840806 0"
        type="matrix"
        in="shadowBlurOuter1"
      ></feColorMatrix>
    </filter>
    <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-4">
      <stop stop-color="#F9FAFC" offset="0%"></stop>
      <stop stop-color="#F1F6FB" offset="100%"></stop>
    </linearGradient>
    <rect id="path-5" x="36.8290637" y="261.671646" width="36" height="36" rx="18"></rect>
    <rect id="path-7" x="34.8290637" y="421.671646" width="36" height="36" rx="18"></rect>
  </defs>
  <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g id="Artboard" transform="translate(-646.000000, -246.000000)">
      <g id="Group" transform="translate(698.129523, 272.304035)">
        <g id="Group-2">
          <rect
            id="Rectangle"
            fill="#FFFFFF"
            x="13.129523"
            y="403.304035"
            width="357"
            height="131"
          ></rect>
          <g id="body">
            <use fill="black" fill-opacity="1" filter="url(#filter-3)" xlink:href="#path-2"></use>
            <path
              stroke="#EDF1F7"
              stroke-width="8"
              d="M51.277704,4 C35.6252303,4 29.0988583,5.26030057 22.3494814,8.86990687 C16.5280367,11.9832495 11.9832495,16.5280367 8.86990687,22.3494814 C5.26030057,29.0988583 4,35.6252303 4,51.277704 L4,689.722296 C4,705.37477 5.26030057,711.901142 8.86990687,718.650519 C11.9832495,724.471963 16.5280367,729.01675 22.3494814,732.130093 C29.0988583,735.739699 35.6252303,737 51.277704,737 L330.722296,737 C346.37477,737 352.901142,735.739699 359.650519,732.130093 C365.471963,729.01675 370.01675,724.471963 373.130093,718.650519 C376.739699,711.901142 378,705.37477 378,689.722296 L378,51.277704 C378,35.6252303 376.739699,29.0988583 373.130093,22.3494814 C370.01675,16.5280367 365.471963,11.9832495 359.650519,8.86990687 C352.901142,5.26030057 346.37477,4 330.722296,4 L51.277704,4 Z"
              stroke-linejoin="square"
              fill="url(#linearGradient-1)"
              fill-rule="evenodd"
            ></path>
          </g>
          <path
            d="M99,8 L283,8 L283,18.5 C283,23.7467051 278.746705,28 273.5,28 L108.5,28 C103.253295,28 99,23.7467051 99,18.5 L99,8 L99,8 Z"
            id="Rectangle-13"
            fill="#EDF1F7"
            fill-rule="nonzero"
          ></path>
          <rect id="Rectangle" fill="#FFFFFF" x="8" y="342" width="365" height="354" rx="29"></rect>
          <rect
            id="Rectangle"
            fill="#CBD6E6"
            opacity="0.424990699"
            x="35.629523"
            y="172.804035"
            width="311"
            height="37"
          ></rect>
          <rect
            id="Rectangle"
            fill="#CBD6E6"
            opacity="0.424990699"
            x="58.129523"
            y="564.304035"
            width="250"
            height="11"
          ></rect>
          <rect
            id="Rectangle"
            fill="#CBD6E6"
            opacity="0.424990699"
            x="58.129523"
            y="584.304035"
            width="250"
            height="11"
          ></rect>
          <rect
            id="Rectangle-Copy-12"
            fill="url(#linearGradient-4)"
            x="58.129523"
            y="420.304035"
            width="250"
            height="127"
            rx="4"
          ></rect>
          <rect
            id="Rectangle"
            fill="#CBD6E6"
            opacity="0.424990699"
            x="35.629523"
            y="226.804035"
            width="311"
            height="11"
          ></rect>
          <rect
            id="Rectangle"
            fill="#CBD6E6"
            opacity="0.424990699"
            x="35.629523"
            y="245.804035"
            width="311"
            height="11"
          ></rect>
          <text
            id="Your-website"
            font-family="Roboto-Regular, Roboto"
            font-size="24"
            font-weight="normal"
            fill="#CBD6E6"
          >
            <tspan x="121.5" y="122.5">Your website</tspan>
          </text>
          <mask id="mask-6" fill="white">
            <use xlink:href="#path-5"></use>
          </mask>
          <g id="Mask"></g>
          <mask id="mask-8" fill="white">
            <use xlink:href="#path-7"></use>
          </mask>
          <g id="Mask"></g>
          <path
            d="M122,7 L257.789474,7 L257.789474,12.5 C257.789474,17.7467051 253.536179,22 248.289474,22 L131.5,22 C126.253295,22 122,17.7467051 122,12.5 L122,7 L122,7 Z"
            id="Rectangle-13"
            fill="#EDF1F7"
            fill-rule="nonzero"
            mask="url(#mask-8)"
          ></path>
          <path
            d="M98.870477,7.69596542 L282.870477,7.69596542 L282.870477,18.1959654 C282.870477,23.4426705 278.617182,27.6959654 273.370477,27.6959654 L108.370477,27.6959654 C103.123772,27.6959654 98.870477,23.4426705 98.870477,18.1959654 L98.870477,7.69596542 L98.870477,7.69596542 Z"
            id="Rectangle-13"
            fill="#EDF1F7"
            fill-rule="nonzero"
            mask="url(#mask-8)"
          ></path>
        </g>
      </g>
    </g>
  </g>
</svg>
